<div class="main-container">
  @if (viewType === 'List') {
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">User Management</span>
      </div>
      <!-- Redirect Button -->
      @if (createUser) {
        <div class="button-group">
          <button class="primary-button" (click)="addUpdateDeleteUser()">
            Add User <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (viewUser) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">User List</h6>
          <div class="component-actions">
            <app-common-component-dropdown-search
              [items]="filteredListOfRoles"
              [initialValue]="roleId"
              [placeHolder]="'Select Role'"
              (itemSelected)="onRoleSelected($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="searchText"
              (searchSubmit)="onSearchUsername($event)"
            ></app-common-search>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <tr>
              <th>Full Name</th>
              <th>Email</th>
              <th>Mobile No.</th>
              <th>Created By</th>
              <th>User Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            @if (listOfUser.length > 0) {
              <tbody>
                @for (user of listOfUser; track user) {
                  <tr>
                    <td>{{ user.firstName }} {{ user.lastName }}</td>
                    <td>
                      {{ user.userEmail }}
                    </td>
                    <td>
                      {{ user.mobileNumber }}
                    </td>
                    <td>
                      {{ user.adminName || '-' }}
                    </td>
                    <td>
                      {{ user.roleName }}
                    </td>
                    <td>
                      {{ user.status }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        <button
                          class="primary-button view-button"
                          (click)="fetchDataById(user.id)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                        @if (deleteUser) {
                          <button
                            class="primary-button delete-button"
                            [disabled]="user.status !== 'Active'"
                            (click)="delete(user.id)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (listOfUser.length < 1) {
              <tbody>
                <tr></tr>
                <tr>
                  <td colspan="10">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <div class="component-footer">
          @if (listOfUser.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalItems"
              [pageSize]="pageSize"
              [currentPage]="currentPage"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }
  }

  @if (viewType === 'Add') {
    <div [formGroup]="userForm">
      <!-- Component Header Section -->
      <div class="page-header">
        <div class="routing-buttons">
          <div
            class="action-button back-button"
            (click)="onBack('List')"
            tabindex="0"
            (keydown.enter)="onBack('List')"
          >
            <mat-icon class="icon back-icon">arrow_back</mat-icon>
          </div>
          <div
            class="action-button reload-button"
            (click)="onRefresh()"
            tabindex="0"
            (keydown.enter)="onRefresh()"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
          <span class="page-title"> User Management</span>
        </div>
      </div>

      <!-- Component Body Section -->
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">
            @if (submitButton) {
              Save User Details
            }
            @if (updateButton) {
              Update User Details
            }
          </h6>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <form [formGroup]="userForm" novalidate>
          <div class="flex-body">
            <div class="image-section">
              @if (!myimage) {
                <div>
                  <img
                    loading="lazy"
                    src="../../assets/profile.png"
                    alt="Profile Picture"
                  />
                </div>
              }
              @if (myimage) {
                <div>
                  <img loading="lazy" [src]="myimage" alt="Profile Picture" />
                </div>
              }
              <input
                #fileUpload
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                style="display: none"
                (change)="onChange($event)"
              />
              @if (updateUsers) {
                <button type="button" (click)="fileUpload.click()">
                  Upload Profile Picture
                </button>
              }
            </div>
            <div class="image-form-section">
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Created By</mat-label>
                  <input
                    matInput
                    formControlName="adminName"
                    placeholder="Created By"
                    readonly
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-select #roleSelect formControlName="roleId">
                    @if (roleSelect.focused) {
                      <mat-select
                        [placeholder]="'Filter'"
                        (filteredReturn)="RoleListForAddUser = $event"
                        onkeydown="return (event.keyCode!=13)"
                      >
                      </mat-select>
                    }
                    @for (item of RoleListForAddUser; track item) {
                      <mat-option [value]="item.roleId">
                        {{ item.userRole }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-label>User Type</mat-label>
                  @if (
                    userForm.controls['roleId'].touched &&
                    userForm.controls['roleId'].errors?.required
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    formControlName="firstName"
                    placeholder="First Name"
                    required
                  />
                  @if (
                    userForm.controls['firstName'].touched &&
                    userForm.controls['firstName'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['firstName'].touched &&
                          userForm.controls['firstName'].errors
                            ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['firstName'].touched &&
                    userForm.controls['firstName'].errors
                      ?.nonNumericNoSpecialChars
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['firstName'].touched &&
                          userForm.controls['firstName'].errors
                            ?.nonNumericNoSpecialChars
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['firstName'].touched &&
                    userForm.controls['firstName'].errors?.maxLengthRequired
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['firstName'].touched &&
                          userForm.controls['firstName'].errors
                            ?.maxLengthRequired
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input
                    matInput
                    formControlName="lastName"
                    placeholder="Last Name"
                    required
                  />
                  @if (
                    userForm.controls['lastName'].touched &&
                    userForm.controls['lastName'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['lastName'].touched &&
                          userForm.controls['lastName'].errors
                            ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['lastName'].touched &&
                    userForm.controls['lastName'].errors
                      ?.nonNumericNoSpecialChars
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['lastName'].touched &&
                          userForm.controls['lastName'].errors
                            ?.nonNumericNoSpecialChars
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['lastName'].touched &&
                    userForm.controls['lastName'].errors?.maxLengthRequired
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['lastName'].touched &&
                          userForm.controls['lastName'].errors
                            ?.maxLengthRequired
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    type="email"
                    placeholder="User Email"
                    formControlName="userEmail"
                    required
                  />
                  @if (
                    userForm.controls['userEmail'].touched &&
                    userForm.controls['userEmail'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['userEmail'].touched &&
                          userForm.controls['userEmail'].errors
                            ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['userEmail'].touched &&
                    userForm.controls['userEmail'].errors?.validEmail
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['userEmail'].touched &&
                          userForm.controls['userEmail'].errors?.validEmail
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Mobile Number</mat-label>
                  <input
                    matInput
                    type="email"
                    placeholder="Mobile Number"
                    formControlName="mobileNumber"
                    required
                  />
                  @if (
                    userForm.controls['mobileNumber'].touched &&
                    userForm.controls['mobileNumber'].errors
                      ?.mobileNumberValidation
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['mobileNumber'].touched &&
                          userForm.controls['mobileNumber'].errors
                            ?.mobileNumberValidation
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Country</mat-label>
                  <input
                    matInput
                    formControlName="country"
                    placeholder="Country"
                    required
                  />
                  @if (
                    userForm.controls['country'].touched &&
                    userForm.controls['country'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['country'].touched &&
                          userForm.controls['country'].errors
                            ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['country'].touched &&
                    userForm.controls['country'].errors
                      ?.nonNumericNoSpecialChars
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['country'].touched &&
                          userForm.controls['country'].errors
                            ?.nonNumericNoSpecialChars
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>State</mat-label>
                  <input
                    matInput
                    formControlName="state"
                    placeholder="State"
                    required
                  />
                  @if (
                    userForm.controls['state'].touched &&
                    userForm.controls['state'].errors?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['state'].touched &&
                          userForm.controls['state'].errors
                            ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['state'].touched &&
                    userForm.controls['state'].errors?.nonNumericNoSpecialChars
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['state'].touched &&
                          userForm.controls['state'].errors
                            ?.nonNumericNoSpecialChars
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Status</mat-label>
                  <mat-select
                    required
                    class="colorblack"
                    formControlName="status"
                  >
                    <mat-option value="Active">Active</mat-option>
                    <mat-option value="In-active">In-active</mat-option>
                  </mat-select>
                  @if (
                    userForm.controls['status'].touched &&
                    userForm.controls['status'].errors?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['status'].touched &&
                          userForm.controls['status'].errors
                            ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </form>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <div class="component-footer">
          <div class="button-group">
            @if (submitButton) {
              <button
                class="submit-button"
                (click)="validateForm()"
                [disabled]="this.userForm.invalid"
              >
                Save User Details
                <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            }
            @if (userUpdate === true && updateButton && updateUsers) {
              <button class="edit-button" (click)="validateFormUpdate()">
                Update User Details <mat-icon class="btn-icon">edit</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
